module.exports = __webpack_public_path__ + "img/header-weddingRingsGold.8ec554d.webp";